import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./errorpage.module.scss";
import ErrorImage from "../../assets/img/error-bg2x.webp";
import { useMetaData } from "../../utils/useMetaData";
import SonicLink from "../../common/routing/SonicLink";

export const ErrorPage: React.FC = () => {
  const { t } = useTranslation();

  useMetaData({
    title: "お探しのページは見つかりませんでした",
    description: "",
    imgUrl: "",
  });

  return (
    <div className={styles["errorpage"]}>
      <h1 className={styles["errorpage_title"]}>404 NOT FOUND...</h1>

      <p className={styles["errorpage_text"]}>
        {t("お探しのページは見つかりませんでした。")}
      </p>

      <img src={ErrorImage} className={styles["errorpage_img"]} />
      <div className={styles["errorpage_link-wrapper"]}>
        <SonicLink to="/" className={styles["errorpage_link"]}>
          <span className={styles["errorpage_link_text"]}>
            {t("サイトTOPへ")}
          </span>
        </SonicLink>
      </div>
    </div>
  );
};

export default ErrorPage;
